import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as NewRoute from "./new";
// Before `:pageId` in both switches below: a page whose id happened to be
// "import" is not a thing this service can mint (they are uuids), but the order
// is what makes that true by construction rather than by luck — the same
// position `/new` already relies on.
import * as ImportRoute from "./import";
import * as ListRoute from "./list";
import * as PageRoute from "./page";
import PagePublicSchema from "@common/schema/page/public";
import * as Section from "@repoflow/components/section";

const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  // Off the SITE's base rather than the app root: every screen below lives at
  // /site/:siteId/page/..., and `params` carries the siteId every query
  // beneath here takes as a variable.
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/page`;
  const basepath = `${parentBasepath}/page`;

  return (
    <Section.Provider
      schema={PagePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/import`} component={ImportRoute.Content} />
          <Route path={`${basepath}/:pageId`} component={PageRoute.Content} />
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <>
            <BreadcrumbItem>
              <Link to={base}>Pages</Link>
            </BreadcrumbItem>
            <Switch>
              <Route path={`${basepath}/new`} component={NewRoute.Indice} />
              <Route path={`${basepath}/import`} component={ImportRoute.Indice} />
              <Route
                path={`${basepath}/:pageId`}
                component={PageRoute.Indice}
              />
              <Route path={`${basepath}/`} component={ListRoute.Indice} />
            </Switch>
          </>
        </>
      )}
    </LocalProvider>
  );
}
export const Sidebar = () => <></>;
